<template>
    <div>
        <div v-if="pending">
            <BaseSpinner />
        </div>
        <template v-else-if="!entry" /> <!-- empty case for when there is no entry, nuxt will show an error -->
        <article v-else>
            <HeroBasic
                :title="entry?.title"
                :description="entry?.description"
            >
                <template #backlink>
                    <NuxtLink :to="t('toegewezen_bijdragen.backlink.uri')">
                        <div class="sr-only">{{ t('a11y.return-to') }}</div>
                        <BaseIcon icon="chevron-left" />
                        {{ t('toegewezen_bijdragen.backlink.label') }}
                    </NuxtLink>
                </template>
            </HeroBasic>

            <FlexibleSections
                v-if="entry?.flexibleSections"
                :sections="entry.flexibleSections"
            />

            <BaseSection>
                <ToegewezenBijdragenCollection />
            </BaseSection>
        </article>
    </div>
</template>

<script setup>
import { formatISO } from 'date-fns';
import getPage from '~/graphql/queries/getPage.graphql';

const { t } = useI18n();

const { variables: defaultVariables }  = useCraftGraphql();

const variables = computed(() => {
    const now = formatISO(Date.now(), { representation: 'date' });

    return {
        ...defaultVariables,
        now: ['or', `>= ${now}`, null]
    };
});

const response = await useAsyncQuery({
    query: getPage,
    variables
});

// using response.pending in template is not reactive???
const pending = computed(() => response?.pending.value);

const { craftEntry: entry } = useCraftPageEther(response);
const mainStore = useMainStore();
watchEffect(() => {
    mainStore.toggleNewsletterSubscribe(entry.value?.showNewsletterSubscribe ?? false);
});
</script>
